import React from 'react';
import styled from 'styled-components';
import { Payment } from '../models/PaymentModels';
import { formatCurrency, maskCardNumber, formatDate } from '../utils/numberFormatter';
import { Table, TableHeader, TableSection } from '../styles/DashboardStyles'; // 기존 스타일 활용

// DashboardPaymentTable Props 인터페이스
interface DashboardPaymentTableProps {
  payments: Payment[];
}

// 테이블 스타일 커스텀 (결제 테이블용)
const StyledTable = styled(Table)`
  th,
  td {
    // white-space: nowrap; // 내용이 길어지면 줄바꿈 방지 (필요시)
    // text-overflow: ellipsis; // 내용이 길어지면 ... 처리 (필요시)
    // overflow: hidden; // 내용이 길어지면 숨김 (필요시)
  }
  td:nth-child(1), th:nth-child(1) { width: 15%; text-align: center; } // 승인날짜
  td:nth-child(2), th:nth-child(2) { width: 15%; } // 결제유저명
  td:nth-child(3), th:nth-child(3) { width: 20%; } // 결제상품명
  td:nth-child(4), th:nth-child(4) { width: 12%; text-align: right; } // 결제금액
  td:nth-child(5), th:nth-child(5) { width: 12%; text-align: center; } // 결제수단
  td:nth-child(6), th:nth-child(6) { width: 13%; text-align: center; } // 카드사
  td:nth-child(7), th:nth-child(7) { width: 13%; text-align: center; } // 카드번호 (마스킹)
`;

const DashboardPaymentTable: React.FC<DashboardPaymentTableProps> = ({ payments }) => {

  return (
    <TableSection> {/* 테이블 전체를 감싸는 컨테이너 */}
      <TableHeader>
        <h3>결제 목록</h3>
      </TableHeader>
      <StyledTable>
        <thead>
          <tr>
            <th>승인날짜</th>
            <th>결제유저명</th>
            <th>결제상품명</th>
            <th>결제금액</th>
            <th>결제수단</th>
            <th>카드사</th>
            <th>카드번호</th>
          </tr>
        </thead>
        <tbody>
          {payments.map((payment, index) => (
            <tr key={index}>
              <td>{formatDate(payment.승인날짜)}</td>
              <td>{payment.결제유저명}</td>
              <td>{payment.결제상품명}</td>
              <td>{formatCurrency(payment.결제금액)}</td>
              <td>{payment.결제수단}</td>
              <td>{payment.카드사}</td>
              <td>{maskCardNumber(payment.카드번호)}</td>
            </tr>
          ))}
          {(!payments || payments.length === 0) && (
            <tr>
              <td colSpan={7} style={{ textAlign: 'center', padding: '20px' }}>
                표시할 결제 데이터가 없습니다.
              </td>
            </tr>
          )}
        </tbody>
      </StyledTable>
    </TableSection>
  );
};

export default DashboardPaymentTable; 